export default function getAllEmployees(locale: string) {
  return groq`*[_type=="employee" && __i18n_lang=="${locale}" && !(_id in path("drafts.**"))]|order(coalesce(__i18n_base->orderRank, orderRank)){
        ...
     }`;
}
